import Controller from '@ember/controller';
import { service } from '@ember/service';
import { action } from '@ember/object';

export default class AccountsAccountController extends Controller {
  @service access;
  @service router;
  @service session;
  @service sidebar;
  @service swingBridge;

  get isEmbeddedInSwing() {
    return this.swingBridge.isEmbeddedInSwing;
  }

  get isSidebarOpen() {
    return this.sidebar.isOpen;
  }

  get padSidebar() {
    return !this.isEmbeddedInSwing && this.sidebar.isOpen;
  }

  get pageTitle() {
    let branchName = '';
    if (this.session.branch && this.session.branchList?.length > 1) {
      branchName = this.session.branch.shortName;
    }
    return branchName;
  }

  @action
  toggleSidebar() {
    this.sidebar.toggleSidebar();
  }

  @action
  validateActivePermissions() {
    if (
      this.session.isAuthenticated &&
      (!this.access.activePermissionsValid ||
        !this.session.currentUserHasAccessToCurrentAccount)
    ) {
      this.router.replaceWith('pin-pad');
    }
  }
}
